import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'kon-price-wrapper',
    imports: [CommonModule],
    template: `
    <div class="relative w-full flex flex-nowrap">
      <ng-container #fieldComponent></ng-container>
      <span
        class="absolute inset-y-0 right-3 flex items-center font-semibold text-primary-900"
      >
        {{ field.props?.['price'] || 0 | currency: 'EUR' }}
      </span>
    </div>
  `
})
export class FormlyPriceWrapperComponent extends FieldWrapper {}
